<template>
  <div class="projectitem" @click="goDetail(project.url)">
    <a href="javascript:void(0);">
      <div class="itemimg">
        <img :src="project.image" />
      </div>
      <div class="wordtop">
        <b>{{project.title}}</b>
      </div>
      <div class="wordbottom">{{project.line}}</div>
      <!-- <div class="wordbottom">
        <img src="/static/index/more2.png" />
      </div>-->
      <div class="blackcover"></div>
    </a>
  </div>
</template>

<script>
export default {
  name: "project",
  props: {
    project: {
      type: Object,
    }
  },
  methods: {
    goDetail(e) {
      // this.$router.push({ name, params: { id: this.project.id } })
      this.$router.push({ name: e })
    }
  }
}
</script>

<style scoped>
.projectitem {
  width: 100%;
  max-width: 32%;
  flex: 0 0 32%;
  /* height: 3.45rem; */
  position: relative;
  overflow: hidden;
  margin-bottom: 0.4rem;
  /* padding-right: 0.4rem; */
  animation-duration: 0.5s;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.5s;
  border-radius: 10px;
  overflow: hidden;
}
.itemimg img {
  cursor: pointer;
  width: 100%;
  /* height: 3.45rem; */
  transition: all 0.6s;
}
/* .projectitem:hover .itemimg img {
  transform: scale(1.1);
} */
.wordtop {
  position: absolute;
  top: 0rem;
  color: white;
  font-size: 0.3rem;
  left: 0rem;
  z-index: 20;
  width: 100%;
  /* padding-right: 0.4rem; */
  padding: 0.4rem;
}
.wordbottom {
  position: absolute;
  bottom: 0rem;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.2rem;
  left: 0rem;
  z-index: 20;
  width: 100%;
  /* padding-right: 0.4rem; */
  padding: 0.4rem;
}
/* 
.wordbottom {
  position: absolute;
  bottom: 0.4rem;
  color: black;
  font-size: 0.18rem;
  line-height: 0.24rem;
  height: 0.24rem;
  left: 0.4rem;
  transition: all 0.6s;
  width: 1.2rem;
  height: 0.3rem;
  z-index: 20;
}
.wordbottom img {
  width: 1.5rem;
  height: 0.37rem;
} */
.blackcover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(49, 50, 51, 0.5);
  transition: all 0.6s;
}
/* .projectitem:hover .blackcover {
  opacity: 0;
  transition: all 0.6s;
}

.projectitem:hover .wordbottom {
  bottom: 0.27rem;
  transition: all 0.6s;
} */

@media (max-width: 1200px) {
  /* .projectitem {
    flex: 0 0 45%;
    max-width: 45%;
  } */
  .wordtop {
    font-size: 0.22rem;
  }
  .wordbottom {
    font-size: 0.14rem;
  }
}

@media (max-width: 992px) {
  .projectitem {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .wordtop {
    font-size: 0.6rem;
  }
  .wordbottom {
    font-size: 0.4rem;
  }
  .projectitem {
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project-item copy.vue